import React from "react";
import "./Plan.css";
import { plansData } from "../../data/plansData.js";
import whiteTick from "../../assets/whiteTick.png";
const Plan = () => {
  return (
    <div className="plans-container">
      <div className="blur plans-blur-1"></div>
      <div className="blur plans-blur-2"></div>
      <div class="programs-header">
        <span class="stroke-text">Ready to Start</span>
        <span>Your Journey</span>
        <span class="stroke-text">now withus</span>
      </div>
      <div className="plans">
        {plansData.map((plan, i) => (
          <div className="plan" key={i}>
            {plan.icon}
            <span>{plan.name}</span>
            <span>$ {plan.price}</span>
            <div className="features">
              {plan.features.map((feature, i) => (
                <div className="feature">
                  <img src={whiteTick} alt="" />
                  <span key={i}>{feature}</span>
                </div>
              ))}
            </div>
            <div>
              <span>See more benefits -&gt;</span>
            </div>
            <button class="btn">Join now</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Plan;
